import { render, staticRenderFns } from "./ComprasPno.vue?vue&type=template&id=594f2037&"
import script from "./ComprasPno.vue?vue&type=script&lang=js&"
export * from "./ComprasPno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports